<ms-split-header #splitHeaderComponent [enableScroll]="isInSheetView">
    <ng-container slot="header">
        @if (showMarketHelp) {
            <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
        }
        @if (isTeamGroupingEnabled) {
            <ms-team-grouping-tab-bar [event]="event" [optionGroup]="optionGroup" (teamGroupingChange)="onTeamGroupingChange($event)" />
        }
    </ng-container>
    <ng-container slot="content">
        <div class="option-group-container player-props-container triple" [style.--option-group-rows]="visibleOptionGroups()">
            <div class="option-group-header">
                <span></span> <span>{{ overHeader }}</span> <span>{{ underHeader }}</span>
            </div>
            <div class="option-group-row flex-column" *rxFor="let optionLine of optionLines$; trackBy: trackOptionLine">
                <div class="d-flex">
                    <div class="attribute-key">
                        @if (isShowHeadshotImage) {
                            <ms-participant-image
                                class="participant-logo"
                                [participantImage]="optionLine.underOption?.image ?? optionLine.overOption?.image"
                                [showLogoColor]="true"
                                [participantType]="participantType.Player"
                                [sportId]="event.sport.id" />
                        }
                        <div class="player-props-player-name">
                            {{ optionLine.playerName }}
                            @if (showPlayerStats && event.playerStats && optionGroup.detailedGrouping.playerStatsProps) {
                                <ms-player-stats
                                    [playerStats]="event.playerStats"
                                    [sportId]="event.sport.id"
                                    [playerStatsProps]="optionGroup.detailedGrouping.playerStatsProps"
                                    [playerIds]="getPlayers(optionLine)"
                                    [source]="optionGroup.source" />
                            }
                        </div>
                        @if (isPlayerStatisticsEnabled && isPlayer(optionLine.playerName)) {
                            <div class="player-stats-icon" [class.active]="optionLine.showStats" (click)="updateStatisticsStore(optionLine)">
                                <vn-icon size="14" [name]="optionLine.showStats ? 'sports-stats-active' : 'sports-stats'" />
                            </div>
                        }
                    </div>
                    @if (optionLine.overOption) {
                        <ms-option
                            [tracking]="{
                                source: tracking,
                                moduleType: trackingModuleType,
                                controllerTabName: controllerTabName,
                                playersName: optionLine.playerName,
                            }"
                            [option]="optionLine.overOption"
                            [optionGroup]="optionGroup"
                            [event]="event"
                            [showPromoBadge]="!!crmPromoIdsMap.options[optionLine.overOption.id]"
                            [sourceOfPick]="sourcesOfPick"
                            [betDetails]="betDetails" />
                    } @else {
                        <ng-container *ngTemplateOutlet="emptyOption" />
                    }
                    @if (optionLine.underOption) {
                        <ms-option
                            [tracking]="getTracking(optionLine)"
                            [option]="optionLine.underOption"
                            [optionGroup]="optionGroup"
                            [event]="event"
                            [showPromoBadge]="!!crmPromoIdsMap.options[optionLine.underOption.id]"
                            [sourceOfPick]="sourcesOfPick"
                            [betDetails]="betDetails" />
                    } @else {
                        <ng-container *ngTemplateOutlet="emptyOption" />
                    }
                </div>
                @if (optionLine.showStats) {
                    <ms-player-statistics
                        [statistics]="playerStatistics()"
                        [marketFilter]="optionGroup.originalId"
                        [tracking]="tracking"
                        [optionGroupName]="optionGroup.name"
                        [messages]="playerStatisticsMessages()"
                        [isSheetViewOpen]="isSheetViewOpen()"
                        [event]="event"
                        [marketId]="(optionLine.overOption?.optionGroupId ?? optionLine.underOption?.optionGroupId)?.toString()"
                        [playerName]="optionLine.playerName" />
                }
            </div>
        </div>
    </ng-container>
</ms-split-header>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}

<ng-template #emptyOption>
    <ms-option-pick-placeholder class="option" />
</ng-template>
